/**
 * Created by Klayer3
 */
import * as Rx from 'rxjs/Rx';

export class ServiceName {
  private static _values = {};
  public static add(name: string, service: any) {
    this._values[name] = service;
  }

  public static get(name: string) {
    return this._values[name];
  }
}

export interface Service<T> {
  dataChange: Rx.Observable<T[]>;
  getData(): Array<T>;
  add(entity: T): Rx.Observable<T>;

  update(entity: T): Rx.Observable<T>;

  remove(entity: T): Rx.Observable<T> ;

  load(entity: T, force?:boolean, add?: boolean): Rx.Observable<T> ;

  loadById(id: any, force?:boolean, add?: boolean): Rx.Observable<T> ;

  loadItems(options?: any): Rx.Observable<T[]> ;

}



// WEBPACK FOOTER //
// ./src/app/core/services/Service.ts